/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
==========================================================================================*/


export default [{
        url: '/dashboard',
        name: "Dashboard",
        slug: "Dashboard",
        icon: "HomeIcon",
        i18n: "Dashboard",
    },
    {
        url: '/admin',
        name: "Admin",
        slug: "admin",
        icon: "UserIcon",
        i18n: "Admin",
    },
    {
        url: '/user',
        name: "User",
        slug: "user",
        icon: "UsersIcon",
        i18n: "User",
    },
    {
        url: null,
        name: "UserFile",
        icon: "FileIcon",
        i18n: "UserFile",
        rule: "user",
        submenu: [{
                url: '/user-file',
                name: "UserFileList",
                slug: "userFileList",
                i18n: "UserFileList",
            },

            {
                url: '/file-download-history',
                name: "FileDownloadHistory",
                slug: "fileDownloadHistory",
                i18n: "FileDownloadHistory",
            },
            {
                url: '/file-upload-history',
                name: "FileUploadHistory",
                slug: "fileUploadHistory",
                i18n: "FileUploadHistory",
            },
        ]
    },
    {
        url: null,
        name: "Subscription",
        icon: "BellIcon",
        i18n: "Subscription",
        rule: "user",
        submenu: [{
                url: '/subscription',
                name: "SubscriptionList",
                slug: "subscriptionList",
                i18n: "SubscriptionList",
            },
            {
                url: '/subscription-payment',
                name: "SubscriptionPaymentHistory",
                slug: "SubscriptionPaymentHistory",
                i18n: "SubscriptionPaymentHistory",
            }
        ]
    },
    {
        url: '/device',
        name: "Device",
        slug: "device",
        icon: "VideoIcon",
        i18n: "Device",
    },
    {
        url: null,
        name: "Streaming",
        icon: "PlayCircleIcon",
        i18n: "Streaming",
        rule: "user",
        submenu: [{
            url: '/streaming-play',
            name: "StreamingPlayRecord",
            slug: "StreamingPlayRecord",
            i18n: "StreamingPlayRecord",
        }, ]
    },
    {
        url: null,
        name: "Report",
        icon: "BarChart2Icon",
        i18n: "Report",
        rule: "user",
        submenu: [{
                url: '/file-stats',
                name: "FileStatisticsReport",
                slug: "FileStatisticsReport",
                i18n: "FileStatisticsReport",
            },
            {
                url: '/streaming-stats',
                name: "StreamingStatisticsReport",
                slug: "StreamingStatisticsReport",
                i18n: "StreamingStatisticsReport",
            },
            {
                url: '/subscription-stats',
                name: "SubscriptionStatisticsReport",
                slug: "SubscriptionStatisticsReport",
                i18n: "SubscriptionStatisticsReport",
            },
            {
                url: '/s3-stats',
                name: "S3StatisticsReport",
                slug: "S3StatisticsReport",
                i18n: "S3StatisticsReport",
            },
            {
                url: '/wowza-stats',
                name: "WowzaStatisticsReport",
                slug: "WowzaStatisticsReport",
                i18n: "WowzaStatisticsReport",
            }
        ]
    },

    {
        url: '/appDownload',
        name: "AppDownload",
        slug: "AppDownload",
        icon: "DownloadIcon",
        i18n: "AppDownload",
    },
    {
        url: null,
        name: "SystemManagement",
        icon: "MonitorIcon",
        i18n: "SystemManagement",
        rule: "user",
        submenu: [
            {
                url: '/server-monitoring',
                name: "ServerMonitoring",
                slug: "ServerMonitoring",
                i18n: "ServerMonitoring",
            },
            {
                url: '/server-monitoring-email',
                name: "ServerMonitoringEmail",
                slug: "ServerMonitoringEmail",
                i18n: "ServerMonitoringEmail",
            },
            {
                url: '/version-management',
                name: "VersionManagement",
                slug: "VersionManagement",
                i18n: "VersionManagement",
            },
            {
                url: '/notice-management',
                name: "NoticeManagement",
                slug: "NoticeManagement",
                i18n: "NoticeManagement",
            },
            {
                url: '/email-management',
                name: "EmailManagement",
                slug: "EmailManagement",
                i18n: "EmailManagement",
            }
        ]
    },
]